<template>
  <div id="profile-card" class="sav-wrapper">
    <Spinner v-if="isLoading"/>
    <Topbar/>
    <div class="sav-container">
        <h1 id="header-title">
            <a href="javascript:void(0)" @click="goBack">
                <img id="header-back-btn" :src="require('./../../assets/icons/arrow-back.png')" alt="Επιστροφή">
            </a>
            <span>Προφίλ</span>
        </h1>

        <div v-if="userData" class="sav-card">
            <div class="sav-card-header">
                <h2 class="sav-card-title"></h2>
                <div class="flex">
                    <router-link to="profile/edit" class="sav-card-icon">
                      <img :src="require('./../../assets/icons/edit.png')" alt="Επεξεργασία"/>
                    </router-link>
                </div>
            </div>
            <div class="sav-card-entries">
                <div class="sav-card-entry">
                    <h3>Όνομα</h3>
                    <p>{{ userData.name }}</p>
                </div>
                <div class="sav-card-entry">
                    <h3>Username</h3>
                    <p>{{ userData.username }}</p>
                </div>
                <div class="sav-card-entry">
                    <h3>Email</h3>
                    <p>{{ userData.email }}</p>
                </div>
            </div> 
            <div class="sav-card-footer">
                <span class="sav-card-log">Τελευταία αλλαγή στις {{ formatDate(userData['modified_date']) }}</span>
                <div class="sav-card-buttons">
                    <router-link to="/change-password" class="sav-btn sav-btn-red">Αλλαγή Κωδικού</router-link>
                </div>
            </div>
        </div>

        <ErrorMsg v-if="errorMsg" :msg="errorMsg"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './../Spinner.vue'
import Topbar from './../Topbar.vue'
import ErrorMsg from './../ErrorMsg.vue'

export default {
  props: [],
  components: {
    Spinner,
    Topbar,
    ErrorMsg
  },
  data() {
    return {
      isLoading: true,
      apiUrl : this.$parent.apiUrl,
      userData: '',
      errorMsg: ''
    }
  },
  methods: {
    formatDate: function (date) {
        // format date dd/mm/yyyy
        let newDate = new Date(date);
        return this.sliceNumber(newDate.getDate(), 2) + "/" + this.sliceNumber(newDate.getMonth() + 1, 2) + "/" + this.sliceNumber(newDate.getFullYear(), 4)
    },
    sliceNumber: function(number, slice) {
      // return number with custom number of digits
      return ("0" + number).slice(-1 * slice);
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
	mounted () {
    const vm = this;
    let formData = {
      user: JSON.parse(localStorage.getItem('sav-erp-user')),
      token: this.$cookie.get('sav-erp-token'),
      refreshToken: this.$cookie.get('sav-erp-refresh-token')
    };

    let headers = { 
			headers: {
			'Content-type': 'application/json',
			}
		};
    
    axios.post(this.apiUrl + '/get/profile/', formData, headers)
      .then(response => {
        vm.isLoading = false;
        if (response.status == 200) {
          this.$cookie.set('sav-erp-token', response.data.token, { expires: '15m' });
          vm.errorMsg = '';
          vm.userData = response.data.data[0];
        } else {
					vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
				}
      })
      .catch(error => {
        let response = error.response;
        
        if (!response) {
          this.errorMsg = "Μη ενεργός server";
        } else {
          if (response.status == 401) {
            localStorage.removeItem('user');    
            vm.$cookie.delete('sav-erp-token');
            vm.$cookie.delete('sav-erp-refresh-token');
            vm.$router.push("/login");
          } else {
            vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
          }
        }
        vm.isLoading = false;
      });
	}
}
</script>

<style lang="scss" scoped>
.sav-card-entry {
    margin-right: 0;
    &:not(:nth-child(3n)) {
        margin-right: 20px;
    }
}

#header-back-btn {
  height: 22px;
}

#header-title {
  font-weight: 500;
  margin-bottom: 30px;
  :not(:last-child) {
    margin-right: 15px;
  }
}
</style>
